"use strict";
/* globals module */
/**
 * @module calendarRsvpAttendeeRoute
 * @description BaasicCalendarRsvpAttendeeRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarRsvpAttendeeRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
;
var contracts_1 = require("../../../../core/contracts");
var CalendarRsvpAttendeeRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarRsvpAttendeeRoute, _super);
    function CalendarRsvpAttendeeRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{?searchQuery,page,rpp,sort,embed,fields,ids,userIds,emails,fullNames,invitationTypeIds,from,to}';
        _this.getRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}';
        _this.getByEmailOrFullNameRoute = 'calendars/{calendarId}/events/{eventId}/attendees/emails/{emailOrFullName}';
        _this.linkRoute = 'calendars/{calendarId}/events/{eventId}/attendees';
        _this.updateRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}';
        _this.updateStatusRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}/status/{attendeeStatusId}';
        _this.updateStatusByEmailOrFullNameRoute = 'calendars/{calendarId}/events/{eventId}/attendees/emails/{emailOrFullName}/status/{attendeeStatusId}';
        _this.unlinkRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}';
        _this.purgeRoute = 'calendars/{calendarId}/events/{eventId}/attendees/purge';
        _this.subscribeEmailRoute = 'calendars/{calendarId}/events/{eventId}/emails/{email}/subscribe';
        _this.unsubscribeEmailRoute = 'calendars/{calendarId}/events/{eventId}/emails/{email}/unsubscribe';
        _this.subscribeRoute = 'calendars/{calendarId}/events/{eventId}/emails/{email}/subscribe';
        _this.unsubscribeRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}/unsubscribe';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarLookupOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventAttendee properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventAttendee subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventAttendee property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `ids` - CalendarEventAttendee ids which uniquely identify CalendarEventAttendee resources that need to be retrieved.
     * - `userIds` - CalendarEventAttende userIds which identify CalendarEventAttendee resources.
     * - `emails` - CalendarEventAttendee emails which identify CalendarEventAttendee resources.
     * - `fullNames` - CalendarEventAttendee full names which identify CalendarEventAttendee resources.
     * - `invitationTypeIds` - invitationTypeIds which identify CalendarEventAttendee resources.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date.
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * @method
     * @param options Query resource GetCalendarLookupOptions object.
     * @param calendarId Calendar identifier which uniquely identifies a calendar resource.
     * @param eventId calendarEvent identifier which uniquely identifies a CalendarEvent resource.
     * @example calendarRsvpAttendeeRoute.find(calendarid, eventid, {searchQuery: '<search-phrase>'});
     */
    CalendarRsvpAttendeeRoute.prototype.find = function (calendarId, eventId, options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        var params = this.modelMapper.findParams(opt);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseFind.call(this, this.findRoute, params);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventAttendee resource in the system. The route can be expanded using additional GetRequestOptions. Supported items are
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource that needs to be retrieved.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param options Query resource GetRequestOptions object.
     * @example calendarRsvpAttendeeRoute.get(calendarId, eventId, id);
     */
    CalendarRsvpAttendeeRoute.prototype.get = function (calendarId, eventId, id, options) {
        var params = this.modelMapper.getParams(options);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseGet.call(this, this.getRoute, id, params);
    };
    /**
     * @method
     * @param calendarId Calendar Id which uniquely identifies a Calendar resource.
     * @param eventId CalendarEvent Id which uniquely identifies a calendarEvent resource
     * @param emailOrFullName Email or full name which identify a CalendarEventRsvpAttendee resource.
     * @param options Query resource options ovject.
     * @example calendarRsvpAttendeeRoute.getByEmailOrFullName(calendarId, eventId, fullname);
     */
    CalendarRsvpAttendeeRoute.prototype.getByEmailOrFullName = function (calendarId, eventId, emailOrFullName, options) {
        var params = this.modelMapper.getParams(options);
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.emailOrFullName = emailOrFullName;
        return _super.prototype.baseGet.call(this, this.getByEmailOrFullNameRoute, {}, params);
    };
    /**
     * Parses link route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies a CalendarEvent resource
     * @param data A CalendarEventAttendee object that needs to be inserted into the system.
     * @example calendarRsvpAttendeeRoute.link(calendarId, eventId, data);
     */
    CalendarRsvpAttendeeRoute.prototype.link = function (calendarId, eventId, data) {
        var params = this.modelMapper.createParams(data);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @example calendarRsvpAttendeeRoute.purge(calendarId, eventId);
     */
    CalendarRsvpAttendeeRoute.prototype.purge = function (calendarId, eventId) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseDelete.call(this, this.purgeRoute, params);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param data A CalendarEventAttendee object used to update specified CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.update(calendarId, eventId, data);
     */
    CalendarRsvpAttendeeRoute.prototype.update = function (calendarId, eventId, data) {
        var params = this.modelMapper.updateParams(data);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    /**
     * Parses update Status route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies CalendarEventAttendeeStatus resource.
     * @example calendarRsvpAttendeeRoute.updateStatus(calendarId, eventId, id, statusId);
     */
    CalendarRsvpAttendeeRoute.prototype.updateStatus = function (calendarId, eventId, id, statusId) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.id = id;
        params.attendeeStatusId = statusId;
        return _super.prototype.baseUpdate.call(this, this.updateStatusRoute, params);
    };
    /**
     * Parses update status email or name route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniqely identifies CalendarEvent resource.
     * @param emailOrFullName Email or FullName
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies CalendarEventAttendeeStatus resource.
     * @example calendarRsvpAttendeeRoute.update(calendarId, eventId, email, statusId);
     */
    CalendarRsvpAttendeeRoute.prototype.updateStatusEmailOrFullName = function (calendarId, eventId, emailOrFullName, statusId) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.emailOrFullName = emailOrFullName;
        params.statusId = statusId;
        return _super.prototype.baseUpdate.call(this, this.updateStatusByEmailOrFullNameRoute, params);
    };
    /**
     * Parses unlink route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param data A CalendarEventAttendee object used to unlink specified CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.delete(calendarId, eventId, data);
     */
    CalendarRsvpAttendeeRoute.prototype.unlink = function (calendarId, eventId, data) {
        var params = this.modelMapper.removeParams(data);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses subscribe route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.subscribe(calendarId, eventId, attendeeId);
     */
    CalendarRsvpAttendeeRoute.prototype.subscribe = function (calendarId, eventId, id) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, params);
    };
    /**
     * Parses unsubscribe route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.unsubscribe(calendarId, eventId, attendeeId);
     */
    CalendarRsvpAttendeeRoute.prototype.unsubscribe = function (calendarId, eventId, id) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.unsubscribeRoute, params);
    };
    /**
     * Parses subscribeEmail route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param email CalendarEventAttendee email which identifies CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.subscribe(calendarId, eventId, attendeeId);
     */
    CalendarRsvpAttendeeRoute.prototype.subscribeEmail = function (calendarId, eventId, email) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.email = email;
        return _super.prototype.baseCreate.call(this, this.subscribeEmailRoute, params);
    };
    /**
     * Parses unsubscribeEmail route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param email CalendarEventAttendee email which identifies CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.unsubscribe(calendarId, eventId, attendeeId);
     */
    CalendarRsvpAttendeeRoute.prototype.unsubscribeEmail = function (calendarId, eventId, email) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.email = email;
        return _super.prototype.baseCreate.call(this, this.unsubscribeEmailRoute, params);
    };
    CalendarRsvpAttendeeRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarRsvpAttendeeRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarRsvpAttendeeRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarRsvpAttendeeRoute);
    return CalendarRsvpAttendeeRoute;
}(common_1.BaseRoute));
exports.CalendarRsvpAttendeeRoute = CalendarRsvpAttendeeRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
